<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <!-- بخش لوگو / نماد شرکت -->
        <v-row no-gutters class="mb-2">
          <v-col cols="12" class="pa-md-3">
            <v-card outlined class="pa-3 rounded-lg bg-light">
              <div class="text-subtitle-2 font-weight-bold mb-2 d-flex align-center">
                <v-icon left small color="primary">mdi-image</v-icon>
                لوگو/ تصویر نماد شرکت
              </div>
              <pic-selector
                :edit-name="false"
                :field.sync="value.image"
                one-pic
                single
              />
            </v-card>
          </v-col>
        </v-row>

        <!-- بخش اول: اطلاعات اصلی و هویتی -->
        <v-row no-gutters>
          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="value.organizationName"
                append-icon="mdi-domain"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                hint="نام رسمی شرکت، کارگاه یا موسسه"
                label="نام مجموعه / شرکت *"
                maxLength="50"
                outlined
                @input="onFieldChange"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-organizationName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="نام مجموعه"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="value.subOrgan"
                append-icon="mdi-subtitles-outline"
                class="contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                hint="مثال: اولین سامانه ساخت کیوآر کد هوشمند"
                label="توضیحات زیر نام مجموعه / شعار"
                maxLength="50"
                outlined
                @input="onFieldChange"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-subOrgan`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="زیر نام مجموعه"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="value.userName"
                append-icon="mdi-account"
                class="contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                hint="شخص تاییدکننده تردد یا مدیر داخلی"
                label="نام و نام خانوادگی مدیر *"
                maxLength="50"
                outlined
                @input="onFieldChange"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-userName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="نام مدیر"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="value.workField"
                append-icon="mdi-briefcase-outline"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                hint="سمت سازمانی مدیر یا حوزه تخصصی"
                label="سمت / حوزه فعالیت"
                maxLength="50"
                outlined
                @input="onFieldChange"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-workField`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="سمت"
              />
            </div>
          </v-col>

          <!-- شماره‌های موبایل پویا -->
          <v-col class="pa-md-3" cols="12" md="6">
            <template v-for="(item, index) in value.phoneNumber">
              <div
                class="rowinfo"
                v-if="!phoneNumberText.includes(index)"
                :key="'phone-' + index"
              >
                <v-text-field
                  v-model="item.number"
                  clearable
                  dense
                  dir="ltr"
                  class="contentinfo"
                  hint="شماره تماس پرسنلی / پیامک اضطراری"
                  label="شماره موبایل"
                  outlined
                  @input="onFieldChange"
                >
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          @click="showPhoneNumberText(index)"
                          v-on="on"
                        >mdi-phone</v-icon>
                      </template>
                      متن عنوان شماره
                    </v-tooltip>

                    <v-icon color="primary" @click="addPhone">mdi-plus</v-icon>
                    <v-icon
                      v-if="value.phoneNumber && value.phoneNumber.length > 1"
                      color="red"
                      @click="removePhone(index)"
                    >mdi-delete</v-icon>
                  </template>
                </v-text-field>
                <help-info
                  v-show="index === 0"
                  :element-name="`${serviceName}-${componentName}-data-phoneNumberText`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="شماره موبایل"
                />
              </div>
              <div class="rowinfo" v-else :key="'phone-txt-' + index">
                <v-text-field
                  v-model="item.text"
                  clearable
                  dense
                  label="عنوان شماره موبایل"
                  outlined
                  class="contentinfo"
                  @input="onFieldChange"
                >
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          @click="showPhoneNumberText(index)"
                          v-on="on"
                        >mdi-text</v-icon>
                      </template>
                      تغییر به ورودی شماره
                    </v-tooltip>
                  </template>
                </v-text-field>
              </div>
            </template>
          </v-col>

          <!-- تلفن ثابت شرکت -->
          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo" v-if="!showCompanyNumberName">
              <v-text-field
                v-model="value.companyNumber"
                clearable
                counter="20"
                dir="ltr"
                class="contentinfo"
                dense
                hint="تلفن ثابت مرکزی شرکت"
                label="شماره تلفن شرکت"
                maxLength="20"
                outlined
                @input="onFieldChange"
              >
                <template v-slot:append-outer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        @click="showCompanyNumberName = true"
                        v-on="on"
                      >mdi-phone</v-icon>
                    </template>
                    عنوان تلفن
                  </v-tooltip>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-companyNumber`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="شماره تلفن"
              />
            </div>
            <div class="rowinfo" v-else>
              <v-text-field
                v-model="value.companyNumberName"
                clearable
                dense
                label="عنوان تلفن شرکت"
                outlined
                class="contentinfo"
                @input="onFieldChange"
              >
                <template v-slot:append-outer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        @click="showCompanyNumberName = false"
                        v-on="on"
                      >mdi-text</v-icon>
                    </template>
                    ورود شماره
                  </v-tooltip>
                </template>
              </v-text-field>
            </div>
          </v-col>

          <!-- تنظیم شعاع مجاز تردد -->
          <v-col class="pa-md-3" cols="12" md="12">
            <v-text-field
              v-model.number="value.allowedRadius"
              append-icon="mdi-radius-outline"
              type="number"
              clearable
              dense
              outlined
              label="شعاع مجاز ثبت تردد (متر) *"
              hint="فاصله مجاز پرسنل از مرکز شرکت برای ثبت تردد"
              persistent-hint
              @input="onFieldChange"
            />
          </v-col>

          <!-- بخش مدیریت پویا و چندگانه شیفت‌های کاری (اختیاری) -->
          <v-col cols="12" class="pa-md-3">
            <v-card outlined class="pa-3 rounded-lg bg-light">
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="d-flex align-center">
                  <v-icon left small color="primary">mdi-clock-time-four-outline</v-icon>
                  <span class="text-subtitle-2 font-weight-bold">
                    شیفت‌های کاری تعریف‌شده در مجموعه (اختیاری)
                  </span>
                </div>
                <v-btn
                  small
                  color="primary"
                  outlined
                  class="rounded-pill"
                  @click="addNewShift"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  افزودن شیفت
                </v-btn>
              </div>

              <!-- حالت بدون شیفت (خالی) -->
              <div
                v-if="!value.shifts || value.shifts.length === 0"
                class="pa-4 text-center grey--text text--darken-1 bg-white rounded elevation-1"
              >
                <v-icon color="grey lighten-1" class="mb-1">mdi-timer-off-outline</v-icon>
                <div class="text-caption">
                  هیچ شیفتی تعریف نشده است (ساعت کاری آزاد / شناور).
                </div>
              </div>

              <!-- ردیف‌های شیفت -->
              <v-row
                v-for="(shift, sIndex) in value.shifts"
                :key="'shift-' + sIndex"
                align="center"
                dense
                class="mb-3 pa-2 rounded bg-white elevation-1 no-gutters shift-row-item"
              >
                <!-- عنوان شیفت -->
                <v-col cols="12" sm="10" md="9" class="px-1 mt-2 mt-sm-0 mb-4">
                  <v-text-field
                    v-model="shift.name"
                    dense
                    outlined
                    hide-details
                    label="عنوان شیفت (مثلاً: صبح / اداری)"
                    class="contentinfo"
                    @input="onFieldChange"
                  />
                </v-col>

                <!-- دکمه‌های کنترلی سطر -->
                <v-col cols="12" sm="3" md="2" class="d-flex align-center justify-start pr-1 mb-2 mb-sm-0 ml-5">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="removeShift(sIndex)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>حذف شیفت</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                        @click="addShiftBelow(sIndex)"
                      >
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>افزودن شیفت بعد از این مورد</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="grey darken-2"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="sIndex === 0"
                        @click="moveShiftUp(sIndex)"
                      >
                        <v-icon small>mdi-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>انتقال به بالا</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="grey darken-2"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="sIndex === value.shifts.length - 1"
                        @click="moveShiftDown(sIndex)"
                      >
                        <v-icon small>mdi-arrow-down</v-icon>
                      </v-btn>
                    </template>
                    <span>انتقال به پایین</span>
                  </v-tooltip>
                </v-col>

                <!-- ورودی زمان پایان -->
                <v-col cols="6" sm="6" md="6" class="px-1">
                  <Timepicker
                    v-model="shift.endTime"
                    label="زمان پایان"
                    class="contentinfo"
                    @input="onFieldChange"
                  />
                </v-col>

                <!-- ورودی زمان شروع -->
                <v-col cols="6" sm="6" md="6" class="px-1">
                  <Timepicker
                    v-model="shift.startTime"
                    label="زمان شروع"
                    class="contentinfo"
                    @input="onFieldChange"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <!-- بخش موقعیت مکانی و نقشه دقیق Map.ir -->
        <v-row no-gutters>
          <v-col class="py-3 px-md-3" cols="12">
            <v-divider />
            <div class="rowinfo">
              <v-textarea
                v-model="value.address"
                append-icon="mdi-map-marker"
                class="mx-0 contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="آدرس دقیق شرکت / محل ثبت تردد"
                outlined
                rows="3"
                @input="onFieldChange"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-location`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="آدرس"
              />
            </div>

            <!-- دکمه‌های ویرایش و حذف لوکیشن -->
            <div class="d-flex align-center flex-column flex-md-row">
              <div
                class="rowinfo flex"
                :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
              >
                <v-btn
                  class="text-white flex contentinfo"
                  :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
                  color="indigo"
                  large
                  @click="showMap = true"
                >
                  <v-icon color="red" class="ml-1">mdi-map-marker</v-icon>
                  {{ value.coordinates && value.coordinates[0] ? 'ویرایش لوکیشن' : 'افزودن لوکیشن' }}
                </v-btn>
              </div>

              <div
                class="rowinfo"
                :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
              >
                <v-btn
                  v-show="value?.coordinates && value.coordinates[0]"
                  class="ms-md-2 mt-2 mt-md-0"
                  :style="$vuetify.breakpoint.mobile ? 'flex: 1 1 auto' : ''"
                  color="red"
                  large
                  outlined
                  @click="removeLocation"
                >
                  <v-icon class="me-2">mdi-close-circle-outline</v-icon>
                  حذف لوکیشن
                </v-btn>
              </div>
            </div>
            <v-divider class="mt-4" />
          </v-col>

          <!-- مودال نقشه مپ‌آی‌آر -->
          <custom-popup
            v-model="showMap"
            :cons="{ title: 'انتخاب موقعیت روی نقشه' }"
            hide-overlay
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <v-card :loading="mapLoading" class="col-12 pa-4">
              <v-row>
                <v-col cols="12" md="6">
                  <city-selector
                    v-model="geoLocation"
                    :search-fn="() => search()"
                  ></city-selector>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="geom"
                    :items="suggests"
                    :search-input.sync="searchTitle"
                    append-icon="mdi-map-marker"
                    append-outer-icon="mdi-magnify"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    item-text="address"
                    item-value="geom"
                    label="جستجوی آدرس در نقشه"
                    outlined
                    @keypress.enter="search"
                    @click:append-outer="search"
                    @input="updateLocationFromAutocomplete"
                  >
                    <template v-if="suggests.length > 0" v-slot:item="data">
                      <v-list style="border-bottom: 1px solid #7e8299">
                        <v-list-item-title class="font-weight-bold mb-2">{{ value.item.title }}</v-list-item-title>
                        <v-list-item-subtitle class="mt-2">{{ value.item.address }} , {{ value.item.region }}</v-list-item-subtitle>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="value.coordinates[1]"
                    label="عرض جغرافیایی (Latitude)"
                    @input="onFieldChange"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="value.coordinates[0]"
                    label="طول جغرافیایی (Longitude)"
                    @input="onFieldChange"
                  ></v-text-field>
                </v-col>
              </v-row>

              <p class="mt-2 font-weight-bold">
                <v-icon color="red">mdi-map-marker</v-icon>
                {{ value.address || 'آدرسی انتخاب نشده است' }}
              </p>

              <mapir
                v-if="value?.coordinates"
                apiKey="GAPGPTMASKTOKEN9me29gmkdl8X0X"
                :center="value?.coordinates"
                :zoom="zoomMap"
                class="col-12"
                style="width: 100%; height: 450px; border-radius: 8px;"
                @click="getlatLng"
              >
                <mapNavigationControl :showUserLocation="true" position="top-right" />
                <mapGeolocateControl position="top-right" show-user-location track-user-location />
                <mapMarker
                  :coordinates.sync="value.coordinates"
                  color="red"
                  draggable
                  kind="marker"
                >
                  <template v-slot:marker>
                    <v-icon large color="red">mdi-map-marker</v-icon>
                  </template>
                </mapMarker>
              </mapir>
            </v-card>
          </custom-popup>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import axios from "axios";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import PicSelector from "../../../../components/UploadCenter/picSelector.vue";
import CitySelector from "@/view/components/citySelector";
import HelpInfo from "../../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import Timepicker from "../../../../components/Timepicker.vue";

export default {
  name: "CompanyAttendanceBaseInfo",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    CitySelector,
    PicSelector,
    Timepicker,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "attendance-base-info",
      searchTitle: "",
      showMap: false,
      geom: null,
      suggests: [],
      mapLoading: false,
      zoomMap: 15,
      geoLocation: {
        city: undefined,
        province: undefined,
      },
      phoneNumberText: [],
      showCompanyNumberName: false,
    };
  },

  created() {
    this.initDefaultValues();
  },

  watch: {
    geom(val) {
      if (val) this.updateLocationFromAutocomplete(val);
    },
    showMap(val) {
      if (val && (!this.value.coordinates || !this.value.coordinates[0])) {
        this.$set(this.value, "coordinates", [51.420296, 35.732379]);
      }
    },
    geoLocation: {
      handler(val) {
        if (val.province && Object.keys(val.province).length > 0) {
          this.value.coordinates = [
            val.province.latitude,
            val.province.longitude,
          ];
          this.getlatLng({
            actualEvent: {
              lngLat: {
                lng: this.value.coordinates[1] || 51.672817,
                lat: this.value.coordinates[0] || 32.657566,
              },
            },
          });
          this.zoomMap = 13;
        }
      },
      deep: true,
    },
  },

  methods: {
    initDefaultValues() {
      const defaults = {
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [{ number: "", text: "" }],
        companyNumber: "",
        companyNumberName: "",
        allowedRadius: 100,
        shifts: [],
        address: "",
        coordinates: [51.420296, 35.732379],
        image: "",
      };

      for (const [key, value] of Object.entries(defaults)) {
        if (this.value[key] === undefined) {
          this.$set(this.value, key, value);
        }
      }

      if (!Array.isArray(this.value.shifts)) {
        this.$set(this.value, "shifts", []);
      }
    },

    addNewShift() {
      if (!Array.isArray(this.value.shifts)) {
        this.$set(this.value, "shifts", []);
      }
      this.value.shifts.push({
        name: `شیفت ${this.value.shifts.length + 1}`,
        startTime: "08:00",
        endTime: "16:00",
      });
      this.onFieldChange();
    },

    addShiftBelow(index) {
      if (!Array.isArray(this.value.shifts)) {
        this.$set(this.value, "shifts", []);
      }
      const newShift = {
        name: `شیفت ${this.value.shifts.length + 1}`,
        startTime: "08:00",
        endTime: "16:00",
      };
      this.value.shifts.splice(index + 1, 0, newShift);
      this.onFieldChange();
    },

    removeShift(index) {
      if (this.value.shifts && this.value.shifts.length > 0) {
        this.value.shifts.splice(index, 1);
        this.onFieldChange();
      }
    },

    moveShiftUp(index) {
      if (index > 0) {
        const item = this.value.shifts.splice(index, 1)[0];
        this.value.shifts.splice(index - 1, 0, item);
        this.onFieldChange();
      }
    },

    moveShiftDown(index) {
      if (index < this.value.shifts.length - 1) {
        const item = this.value.shifts.splice(index, 1)[0];
        this.value.shifts.splice(index + 1, 0, item);
        this.onFieldChange();
      }
    },

    handlePicChange(file) {
      this.$set(this.value, "image", file);
      this.$emit("pic-change", file);
      this.onFieldChange();
    },

    onFieldChange() {
      this.$emit("input", this.value);
      this.$emit("change", this.value);
    },

    addPhone() {
      if (!Array.isArray(this.value.phoneNumber)) {
        this.$set(this.value, "phoneNumber", []);
      }
      this.value.phoneNumber.push({ number: "", text: "" });
      this.onFieldChange();
    },

    removePhone(index) {
      if (this.value.phoneNumber.length === 1) {
        this.value.phoneNumber[0].number = "";
        this.value.phoneNumber[0].text = "";
      } else {
        this.value.phoneNumber.splice(index, 1);
      }
      this.onFieldChange();
    },

    showPhoneNumberText(index) {
      if (this.phoneNumberText.includes(index)) {
        this.phoneNumberText.splice(this.phoneNumberText.indexOf(index), 1);
      } else {
        this.phoneNumberText.push(index);
      }
    },

    removeLocation() {
      this.$set(this.value, "coordinates", [null, null]);
      this.$set(this.value, "address", "");
      this.onFieldChange();
    },

    updateLocationFromAutocomplete(geom) {
      if (geom && geom.address) {
        this.$set(this.value, "address", geom.address);
        this.$set(this.value, "coordinates", geom.coordinates);
      }
      this.getBySearch();
      this.onFieldChange();
    },

    getlatLng(e) {
      this.mapLoading = true;
      this.value.coordinates = [
        e.actualEvent.lngLat.lng,
        e.actualEvent.lngLat.lat,
      ];

      axios({
        method: "GET",
        url: "https://map.ir/reverse",
        params: {
          lat: this.value.coordinates[1],
          lon: this.value.coordinates[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key": process.env.VUE_APP_MAPIR_API_KEY || "YOUR_KEY",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.$set(this.value, "address", response.value.address || "");
          this.onFieldChange();
        })
        .catch(() => {
          this.mapLoading = false;
          this.$toast.error("خطا در دریافت آدرس از نقشه");
        });
    },

    search() {
      this.mapLoading = true;
      const filter = `city eq ${this.geoLocation.province?.name || ""}`;

      axios
        .post(
          "https://map.ir/search/v2/autocomplete",
          {
            text: this.searchTitle || "تهران",
            $filter: filter,
            $select: "poi,roads,neighborhood,county",
          },
          {
            timeout: 15000,
            headers: {
              "x-api-key": process.env.VUE_APP_MAPIR_API_KEY || "YOUR_KEY",
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          this.mapLoading = false;
          this.suggests = response.value.value || [];
          if (this.suggests.length > 0 && this.suggests[0].geom?.coordinates) {
            this.value.coordinates = this.suggests[0].geom.coordinates;
          }
          this.searchTitle = "";
          this.onFieldChange();
        })
        .catch(() => {
          this.mapLoading = false;
        });
    },

    getBySearch() {
      if (!this.geom || !this.geom.coordinates) return;
      this.mapLoading = true;
      this.value.coordinates = this.geom.coordinates;
      axios({
        method: "GET",
        url: "https://map.ir/reverse",
        params: {
          lat: this.value.coordinates[1],
          lon: this.value.coordinates[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key": process.env.VUE_APP_MAPIR_API_KEY || "YOUR_KEY",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.$set(this.value, "address", response.value.address || "");
          this.onFieldChange();
        })
        .catch(() => {
          this.mapLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.bg-light {
  background-color: #fafbfc;
}
.shift-row-item {
  border: 1px solid #edf2f7;
  transition: all 0.2s ease;
}
.shift-row-item:hover {
  border-color: #cbd5e1;
}
[dir="rtl"] .contentinfo,
[dir="rtl"] .rowinfo {
  text-align: right;
}
</style>
